import { LibraryItemShareStatus } from '../constants/PowerPivotSharingStatus';

export enum LibraryItemErrorEnum {
  // As per PBIs 102503 and 108381
  // Case 1a: When there's an issue with the general connection with Sharepoint (PwC view)
  // Case 1b: When there's an issue with the general connection with Sharepoint (Client view)
  SharepointConnectionFailure = 104,

  // Case 2a: When there's an issue with the File (such as issue with upload, aspose issue, file being moved/deleted, tab being deleted) (PwC view)
  // Case 2b: When there's an issue with the File (such as issue with upload, aspose issue, file being moved/deleted, tab being deleted) (Client view)
  FailedToSaveLibraryItem = 102,
  FailedToProcessFile = 103,

  // Case 3a: If the error does not fall under the first 2 scenarios, then Generic Error Message for eg. "Unable to load" including the library load issue (PwC view)
  // Case 3b: If the error does not fall under the first 2 scenarios, then Generic Error Message for eg. "Unable to load" including the library load issue (Client view)
  GenericError = 105,

  // Library item sharing failed
  SharingFailed = 164,
}

export enum LibraryItemStatus {
  InProgress = 1,
  Success = 2,
  Failed = 3,
}

export interface ILibraryItemData {
  driveId?: string;
  driveItemId?: string;
  embeddedUrl: string;
  errorCode?: LibraryItemErrorEnum;
  name: string;
  sharePointItemUrl: string;
  siteId?: string;
  uniqueId: string;
  worksheetName: string;
  status?: LibraryItemShareStatus;
  isShared?: boolean;
  hideWorkSheets?: boolean;
}
